import '../index.less';

import { Divider } from 'antd';

import InfoGrid from '../../../components/InfoGrid';
import { trimPhoneNo } from '../../../utils/number.util';
import { AccountEnquiryResponse } from '../../../features/collection/collectionSlice';

type EmergencyInformationProps = {
  accountEnquiry: AccountEnquiryResponse;
};

const EmergencyInformation: React.FC<EmergencyInformationProps> = (props) => {
  const { accountEnquiry } = props;

  const application = accountEnquiry?.agreementDetails?.application;

  const emergencyInformation = [
    {
      title: 'Emergency Contact Person Name',
      value:
        accountEnquiry?.accountDetails?.emergencyContactName ?? application?.emergencyContactName,
    },
    {
      title: 'Relationship',
      value:
        accountEnquiry?.accountDetails?.applicantEmergencyContactRelationship ??
        application?.applicantEmergencyContactRelationship,
    },
    {
      title: 'Emergency Contact No.',
      value: trimPhoneNo(
        accountEnquiry?.accountDetails?.emergencyContactNo ?? application?.emergencyContactNo
      ),
    },
    {
      title: 'Emergency Contact Email Address',
      value:
        accountEnquiry?.accountDetails?.emergencyContactPersonEmail ??
        application?.emergencyContactPersonEmail,
    },
    {
      title: 'Second Emergency Contact Person Name',
      value:
        accountEnquiry?.accountDetails?.secondEmergencyContactName ??
        application?.secondEmergencyContactName,
    },
    {
      title: 'Second Emergency Relationship',
      value:
        accountEnquiry?.accountDetails?.applicantSecondEmergencyContactRelationship ??
        application?.applicantSecondEmergencyContactRelationship,
    },
    {
      title: 'Second Emergency Contact No.',
      value: trimPhoneNo(
        accountEnquiry?.accountDetails?.secondEmergencyContactNo ??
          application?.secondEmergencyContactNo
      ),
    },
  ];

  return (
    <div className="account-enquiry-container">
      <div className="account-enquiry-section-container">
        <h3 className="account-enquiry-section-subtitle">Emergency Information</h3>
        <Divider style={{ margin: 0 }} />
        <div className="info-container">
          <InfoGrid data={emergencyInformation} />
        </div>
      </div>
    </div>
  );
};

export default EmergencyInformation;
